import { ArrowRightIcon, CalendarIcon } from "@xola/icons";
import { DateFormat } from "common";
import { isArray } from "lodash";
import React from "react";
import { Audit, Purchase, PurchaseItem } from "types";
import { TimelineItem, TimelinePill } from "../TimelineItem";

interface ArrivalTimelineItemProps {
    purchase: Purchase;
    item: PurchaseItem;
    audit: Audit;
    showDate?: boolean;
}

export const ArrivalTimelineItem = ({ purchase, item, audit, showDate = false }: ArrivalTimelineItemProps) => {
    const [from, to] = getDates(item, audit);

    if (!ArrivalTimelineItem.supportsAudit(purchase, item, audit)) {
        return null;
    }

    return (
        <TimelineItem title="Arrival Changed" audit={audit} icon={<CalendarIcon />} color="primary" showDate={showDate}>
            <div>
                <div className="flex items-center space-x-4" data-testid="arrival-timeline-item-arrival-from-to">
                    <TimelinePill icon={<CalendarIcon />}>{from?.format(DateFormat.DATE_TIME_SHORT)}</TimelinePill>
                    <ArrowRightIcon />
                    <TimelinePill icon={<CalendarIcon />}>{to?.format(DateFormat.DATE_TIME_SHORT)}</TimelinePill>
                </div>
            </div>
        </TimelineItem>
    );
};

ArrivalTimelineItem.supportsAudit = (_purchase: Purchase, item: PurchaseItem, audit: Audit) => {
    const [from, to] = getDates(item, audit);
    return from && to;
};

export const getDates = (item: PurchaseItem, audit: Audit) => {
    if (audit.data?.items) {
        const matchingAuditItem: any =
            isArray(audit.data?.items) &&
            audit.data.items.find((auditItem: any) => {
                return auditItem.id === item?.id && auditItem.arrivalDateTime;
            });

        if (matchingAuditItem?.arrivalDateTime && !matchingAuditItem?.product) {
            // Old - new to get a positive amount because we are returning money
            return [matchingAuditItem.arrivalDateTime.old, matchingAuditItem.arrivalDateTime.new];
        }
    }

    return [null, null];
};
